package pl.finn.forms.swz

object swzData {
    val listOfTypesOfReturns = listOf(
        "drogą elektroniczną" to "drogą elektroniczną",
        "na adres korespondencyjny" to "na adres korespondencyjny",
        "odbiorę osobiście" to "odbiorę osobiście"
    )
}